// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.scroll-progress{overflow:hidden}.scroll-progress__rail{height:5px;left:0!important;position:fixed;width:100vw;z-index:15}.scroll-progress__indicator{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#000;border:none;height:100%;transform:scaleX(0);transform-origin:top left;width:100%;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
